<div class="wrap">
  <fa-icon [icon]="getFaIcon('faTimesCircle')" (click)="close()" class="close" appChangeColorTheme attribute="color"></fa-icon>

  <div class="username" *ngIf="userConnect">
    <fa-icon [icon]="getFaIcon('faUser')" appChangeColorTheme attribute="color"></fa-icon>
    <span>{{userConnect?.middle_name}}</span>
  </div>

  <ul class="menu" *ngIf="userConnect">
      <li *ngFor="let m of listLink" [routerLink]="[m?.url]" routerLinkActive="router-link-active" (click)="close()" > {{m.name}}</li>
  </ul>

  
  <button class="sign_in" *ngIf="!userConnect" [routerLink]="['/home/sign-in']" routerLinkActive="router-link-active"
    (click)="changeRoute()">
    <fa-icon [icon]="getFaIcon('faSignAlt')"></fa-icon>
    <span>Se connecter</span>
  </button>

  <button class="sign_up" *ngIf="!userConnect" [routerLink]="['/home/sign-up']" routerLinkActive="router-link-active"
    (click)="changeRoute()">
    <fa-icon [icon]="getFaIcon('faUserPlus')"></fa-icon>
    <span>S'inscrire</span>
  </button>

  <button class="admin" *ngIf=" userConnect && ['admin', 'club', 'counter', 'planning'].includes(userConnect.role)" [routerLink]="['/admin']"
    routerLinkActive="router-link-active" (click)="changeRoute()">
    <fa-icon [icon]="getFaIcon('faCog')"></fa-icon>
    <span>Admin</span>
  </button>

  <button class="log_out" *ngIf="userConnect" [routerLink]="['/']" routerLinkActive="router-link-active"
    (click)="logout()">
    <fa-icon [icon]="getFaIcon('faSignOutAlt')"></fa-icon>
    <span>Se déconnecter</span>
  </button>
</div>
